import React from 'react';
import AttachFileOutlined from '@mui/icons-material/AttachFileOutlined';
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import StatCard from '../StatCard'

const CardAnexosPendentes = (props) => {
  const totalAnexosPendentes = useSelector((state) => state.dashboard?.dashboard?.totalAnexosPendentes)

  return (
    <StatCard
      {...props}
      label="Anexos pendentes de aprovação"
      value={totalAnexosPendentes ? totalAnexosPendentes : 0}
      icon={<AttachFileOutlined />}
    />
  );
}

CardAnexosPendentes.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
}

export default CardAnexosPendentes
